import { inject } from '@angular/core';
import { ProfileService } from '@hemro/lib/profile';
import { forkJoin, from, Observable } from 'rxjs';
import { NavigationService } from './core/navigation/navigation.service';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const profileService = inject(ProfileService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([navigationService.get(), from(profileService.init())]);
};
